export const timeslotKindLimitationCarTypeConstants = {
	MOTORCYCLE: 'motorcycle',
	CAR: 'car',
	COMPANY_CAR: 'company_car',
};

export const timeslotKindLimitationCarFuelTypeConstants = {
	ELECTRIC: 'electric',
	HYBRID: 'hybrid',
	PETROL: 'petrol',
	DIESEL: 'diesel',
	LPG: 'lpg',
};
